import APIService from './api-service';
import config from './config';

export default class MasterDataService extends APIService {
	/**
	 *
	 * @param {String} type
	 * @param {String} subType
	 */
	static getLenderList(type, subType) {
		let url = config.baseUrl[type];
		if (subType) {
			url += `/${subType}`;
		}
		return this.get(`${url}/master/lender-list`);
	}
	static checkBREstatus(type, subType,leadId,lender_id) {
		let url = config.baseUrl[type];
		if (subType) {
			url += `/${subType}`;
		}
		return this.get(`${url}/lead/check-bre-map-lender/${leadId}/${lender_id}`);
	}
	/**
	 *
	 * @param {String} type
	 * @param {String} subType
	 */
	static getProductList(type, subType) {
		let url = config.baseUrl[type];
		if (subType) {
			url += `/${subType}`;
		}
		return this.get(`${url}/master/product-list`);
	}
	/**
	 *
	 * @param {String} type
	 * @param {String} subType
	 */
	static getportfoliodetail(type, subType) {
		let url = config.baseUrl[type];
		if (subType) {
			url += `/${subType}`;
		}
		return this.get(`${url}/dashboard/portfolio `);
	}
	/**
		 *
		 * @param {String} type
		 * @param {String} subType
		 */
	static getTableData(type, subType, routes, selectedMonths, selectedlenderData, selectedprograam, selectedyear,leadType,assignDateFrom,assignDateTo) {

		let url = config.baseUrl[type];
		if (subType) {
			url += `/${subType}`;
		}
		return this.get(`${url}/dashboard/portfolio/${routes}?months=${selectedMonths}&year=${selectedyear}&lender_ids=${selectedlenderData}&prod_cat=${selectedprograam}&lead_type=${leadType}&from_date=${assignDateFrom}&to_date=${assignDateTo}`,);
	}
	static getexcelTableData(type, subType, routes, selectedMonths, selectedlenderData, selectedprograam, selectedyear,leadType,assignDateFrom,assignDateTo,exportExcel) {

		let url = config.baseUrl[type];
		if (subType) {
			url += `/${subType}`;
		}
		if (exportExcel === 1) {
			let responseType = 'blob'
			return this.get(`${url}/dashboard/portfolio/${routes}?months=${selectedMonths}&year=${selectedyear}&lender_ids=${selectedlenderData}&prod_cat=${selectedprograam}&lead_type=${leadType}&from_date=${assignDateFrom}&to_date=${assignDateTo}&export=${exportExcel}`, null, responseType);
		}
	}
	/**
	 *
	 * @param {String} type
	 * @param {String} subType
	 */
	static getProductTypeList(type, subType) {
		let url = config.baseUrl[type];
		if (subType) {
			url += `/${subType}`;
		}
		return this.get(`${url}/master/product-type-list`);
	}

	/**
	 *
	 * @param {String} type
	 * @param {String} subType
	 */
	static getStatusList(type, subType) {
		let url = config.baseUrl[type];
		if (subType) {
			url += `/${subType}`;
		}
		return this.get(`${url}/master/status-list`);
	}
	/**
	 *
	 * @param {String} type
	 * @param {String} subType
	 */
	static getReasonsList(type, subType) {
		let url = config.baseUrl["admin"];
		if (subType) {
			url += `/${subType}`;
		}
		return this.get(
			`${url}/master/reasons-list?type=1`
		);
	}

	/**
	 *
	 * @param {String} type
	 * @param {String} subType
	 */
	static getDocumentList(type, subType, leadId, lenderId) {
		let url = config.baseUrl[type];
		if (subType) {
			url += `/${subType}`;
		}
		return this.get(`${url}/master/document-list/${leadId}/${lenderId ? lenderId:0}`);
	}
	static uploadDocument(type, subType, leadId, formData, lenderId) {
		let url = config.baseUrl[type];
		if (subType) {
			url += `/${subType}`;
		}
		return this.post(
			`${url}/lead/documents/${leadId}/${lenderId ? lenderId:0}`,
			formData,
			null,
			null,
			{
				'Content-Type': 'multipart/form-data',
			}
		);
	}
	static getLenderListByLeadId(type, subType, leadId, listType) {
		let url = config.baseUrl[type];
		if (subType) {
			url += `/${subType}`;
		}
		return this.get(
			`${url}/master/lender-list/${leadId}${listType ? `?type=${listType}` : ''
			}`
		);
	}
	static getAuditTrailLender(type, subType, leadId) {
		let url = config.baseUrl[type];
		if (subType) {
			url += `/${subType}`;
		}
		return this.get(
			`${url}/master/all-lender-list/${leadId}`
		);
	}


	static getPreapprovedLenders(type, subType, leadId) {
		let url = config.baseUrl[type];
		if (subType) {
			url += `/${subType}`;
		}
		return this.get(`${url}/master/preapproved-lender-list/${leadId}`);
	}
	static savePreapprovedLenderLead(type, subType, leadId, lenderId, comment) {
		let url = config.baseUrl[type];
		if (subType) {
			url += `/${subType}`;
		}
		return this.post(`${url}/master/save-preapproved-lender-lead`, {
			cl_lead_id: leadId,
			lender_id: lenderId,
			comment,
		});
	}

	static getLAF(type, subType, leadId) {
		let url = config.baseUrl[type];
		if (subType) {
			url += `/${subType}`;
		}
		return this.get(`${url}/lead/get-lead-info/${leadId}`);
	}

	static fetchLafData(type, subType, leadId) {
		let url = config.baseUrl[type];
		if (subType) {
			url += `/${subType}`;
		}
		return this.get(`${url}/lead/update-data-according-dump-info/${leadId}`);
	}

	static getUserType(type, subType, userId) {
		let url = config.baseUrl[type];
		return this.get(`${url}/check-user-type/${userId}`);
	}

	static getBranchList(type, subType, leadId, lenderName) {
		let url = config.baseUrl[type];
		if (subType) {
			url += `/${subType}`;
		}
		return this.get(`${url}/master/mas-branch-list/${leadId}/${lenderName}`);
	}
}
